import React from "react";

const EthiccraftActionSection = () => {
  const features = [
    {
      icon: "🧭",
      title: "Values-Based Activities",
      desc: "From discussions to campus campaigns, every Ethiccraft activity is designed to nurture integrity, empathy, and leadership.",
    },
    {
      icon: "🛠️",
      title: "Skill-Building Opportunities",
      desc: "Workshops, drives, and real-world projects help you build communication, teamwork, and decision-making skills — all rooted in values.",
    },
    {
      icon: "🌍",
      title: "Community-Driven Impact",
      desc: "Be part of a mission-focused network that turns ideas into action and creates meaningful change on and off campus.",
    },
  ];

  return (
    <div className="ethicraft-action-container">
      <div className="ethicraft-action-content" data-aos="fade-right">
        <h1 className="ethicraft-action-title">
          <span>✨ Ethiccraft </span> In Action{" "}
        </h1>
        <div className="ethicraft-action-features">
          {features.map((feature, index) => (
            <div
              key={index}
              className="ethicraft-feature-item"
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >
              <div className="ethicraft-feature-icon">{feature.icon}</div>
              <div className="ethicraft-feature-text">
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="ethicraft-action-image-container" data-aos="fade-left">
        <div className="ethicraft-image-wrapper">
          <img
            src={"/assets/action.jpg"}
            alt="Ethiccraft activity in action"
            className="ethicraft-action-image"
          />
        </div>
      </div>
    </div>
  );
};

export default EthiccraftActionSection;
